import TyCell from './TyCell.vue'
export default TyCell



// WEBPACK FOOTER //
// ./src/components/ty-cell/index.js